/**
 * This method intercepts all actions of the application,
 * allowing to include any logic before being dispatched to the reducers.
 * @type {{pending: function(*=): {type: *}, success: function(*=, *): {type: *}, error: function(*=, *): {type: *}}}
 */
import { createAction } from "./CommonFunctions/ReduxHelper";

export const actions = {
  pending: (type, payload) => {
    // Any logic here before being dispatched to the reducers
    return createAction(type, { payload });
  },
  success: (type, payload) => {
    // Any logic here before being dispatched to the reducers
    return createAction(type, { payload });
  },
  error: (type, payload) => {
    // Any logic here before being dispatched to the reducers
    return createAction(type, { payload });
  },
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/actionsCreator.js